var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9844 18.3887V7.41992H2.01562V18.3887H15.9844ZM12.9844 0.388672H15V2.4043H15.9844C16.5156 2.4043 16.9844 2.60742 17.3906 3.01367C17.7969 3.41992 18 3.88867 18 4.41992V18.3887C18 18.9199 17.7969 19.3887 17.3906 19.7949C16.9844 20.2012 16.5156 20.4043 15.9844 20.4043H2.01562C1.45312 20.4043 0.96875 20.2168 0.5625 19.8418C0.1875 19.4355 0 18.9512 0 18.3887V4.41992C0 3.88867 0.1875 3.41992 0.5625 3.01367C0.96875 2.60742 1.45312 2.4043 2.01562 2.4043H3V0.388672H5.01562V2.4043H12.9844V0.388672ZM14.0156 11.4043V16.4199H9V11.4043H14.0156Z",
    fill: "#92929D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.489b276b63e27f7ab6a985541d69a9f9.svg";
export { ForwardRef as ReactComponent };